import { render } from "./SuspendLoading.vue?vue&type=template&id=7dc3205d&scoped=true&ts=true"
import script from "./SuspendLoading.vue?vue&type=script&lang=ts"
export * from "./SuspendLoading.vue?vue&type=script&lang=ts"

import "./SuspendLoading.vue?vue&type=style&index=0&id=7dc3205d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc3205d"]])

export default __exports__